import { render, staticRenderFns } from "./RuleTemplateForm.vue?vue&type=template&id=d0a0c642&"
import script from "./RuleTemplateForm.vue?vue&type=script&lang=js&"
export * from "./RuleTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports